import React from 'react';
import './PlaceholderPage.css';

const PlaceholderPage = ({ title, description, icon }) => {
  return (
    <div className="placeholder-page">
      <div className="placeholder-content">
        <div className="placeholder-icon">{icon}</div>
        <h1 className="placeholder-title">{title}</h1>
        <p className="placeholder-description">
          {description || 'This feature is coming soon. Stay tuned for updates!'}
        </p>
        <div className="placeholder-badge">Coming Soon</div>
      </div>
    </div>
  );
};

export default PlaceholderPage;
